import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="text-base font-heading font-semibold text-foreground-950 mb-4">
              最新发布页
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚平台全部最新内容，实时更新、分类清晰，让您第一时间获取最新资讯、产品、公告与活动信息。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                >
                  隐私政策
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors duration-200 cursor-pointer"
                >
                  服务条款
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-950 mb-4">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-base"></i>
                <span>contact@gdbtui7.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市海淀区中关村大街1号</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70 py-5">
        <div className="mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 最新发布页. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="GitHub">
              <i className="ri-github-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}